module.exports = __webpack_public_path__ + "img/home_slider_02.f0a3e1b8.jpg";